import { NavLink } from 'react-router-dom'

import estilos from './BarraInferior.module.css'

/**
 * El menú del técnico: flotante, abajo, tres cosas.
 *
 * El operario no necesita un árbol de secciones: tiene tres pantallas y las
 * alcanza con el pulgar sin abrir nada. Inicio (lo de hoy), Programación (su
 * calendario) e Historial (lo terminado). Solo se muestra para el operario.
 */
const IconoInicio = (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 11.5 12 4l9 7.5" />
    <path d="M5 10v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9" />
  </svg>
)

const IconoCalendario = (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3.5" y="5" width="17" height="16" rx="2.5" />
    <path d="M3.5 9.5h17M8 3.5v3M16 3.5v3" />
  </svg>
)

const IconoHistorial = (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" />
    <path d="M5 3.5v3h3" />
    <path d="M12 8v4.3l2.8 1.7" />
  </svg>
)

const PESTANAS = [
  { a: '/mi-trabajo', rotulo: 'Inicio', icono: IconoInicio },
  { a: '/mi-programacion', rotulo: 'Programación', icono: IconoCalendario },
  { a: '/mi-historial', rotulo: 'Historial', icono: IconoHistorial },
]

export function BarraInferior() {
  return (
    <nav className={`${estilos.barra} no-imprimir`} aria-label="Menú del técnico">
      {PESTANAS.map((p) => (
        <NavLink
          key={p.a}
          to={p.a}
          className={({ isActive }) => `${estilos.tab} ${isActive ? estilos.activo : ''}`}
        >
          {p.icono}
          <span className={estilos.rotulo}>{p.rotulo}</span>
        </NavLink>
      ))}
    </nav>
  )
}
